import React from "react";

// Root of every CRM screen: the prototype puts Inter on body, app.admin keeps
// Poppins there, so the CRM font and text colour start here instead.
const CrmScope = ({ className = "", children }) => (
  <div className={`font-crm text-body antialiased${className ? ` ${className}` : ""}`}>
    {children}
  </div>
);

export default CrmScope;
